<div [formGroup]="form">
  <mat-form-field class="form-field">
    @if (hasIcon()) {
      <mat-icon matPrefix [matTooltip]="getToolTipText()">{{ iconName }}</mat-icon>
    }
    <input
      [readonly]="isReadOnly"
      matInput
      type="text"
      [placeholder]="placeHolder"
      [formControlName]="controlName"
      [width]="width"
      [style]="style" />
  </mat-form-field>
</div>
